export const LOCALES = { DE: 'de', EN: 'en' }
